import strings from "components/release/useful-links/UsefulLinks.strings.json";
import { generateLinksBase } from "components/release/useful-links/helpers/generateLinksBase";
import {
  LinkOptions,
  linksMap,
} from "components/release/useful-links/helpers/linksMap";
import type { SemVer } from "util/version";

// Generate list of links for Crashlytics for minor build version
export const generateJeevesLinks = (versions: SemVer[]): JSX.Element[] =>
  generateLinksBase(versions, strings.Jeeves, linksMap[LinkOptions.JEEVES]);
